import axios from './axios';

// PATCH employee details
export async function patchEmployeeDetails(employeeId, patchData) {
  try {
    const response = await axios.patch(`/owner/employees/${employeeId}/`, patchData);
    return response.data;
  } catch (error) {
    throw error;
  }
}
